<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
            <ul v-if='validationErrors'>
                <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
            </ul>
          </div>
          <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
            {{success}}
          </div>
            <div class="col-lg-6 col-sm-6" style='padding: 0px;'>
              <div class='row' style='text-align:center; padding: 10px'>
              <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                  <span>قيمة القسط:</span>
                  <input v-model='record.amount' class='form-control' name='contract_id' type='text'>
              </div>
              <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                  <span>تاريخ الاستحقاق:</span>
                  <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.due_date'></Datepicker>
              </div>
              <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                  <span>تاريخ السداد:</span>
                  <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.payment_date'></Datepicker>
              </div>
              <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <span>م سابقة:</span>
                  <input @keypress="isLocked($event)" :value='total_paid' class='form-control' name='contract_id' type='text'>
              </div>
              <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <span>المطلوب:</span>
                  <input @keypress="isLocked($event)" :value='((record.amount - this.total_paid)|| 0)' class='form-control' type='text'>
              </div>
              <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <span>المدفوع:</span>
                  <input v-model='record.payed' @keypress="isNumber($event)" class='form-control' name='amount' type='text'>
              </div>
              <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                  <span>الباقى:</span>
                  <input @keypress="isLocked($event)" v-model='remaining' class='form-control' name='amount' type='text'>
              </div>
              <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                  <span>الايصال:</span>
                  <input v-model='record.receipt_id' @keypress="isNumber($event)" class='form-control' name='amount' type='text'>
              </div>
              <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                  <span>الخزنة:</span>
                  <select @change='changeTreasury($event.target.value)' class="form-control" style="padding: 0px" v-model="record.treasury_id">
                    <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                      {{ treasury.name }}
                    </option>
                  </select>
              </div>
                <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 10px 10px;'>
                    <span>المحصل:</span>
                    <select :disabled = 'collectorLocked' class="form-control" style="padding: 0px" v-model="record.collector_id">
                      <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                        {{ collector.name }}
                      </option>
                    </select>
                </div>
                <!-- <div v-show="!isFromReceipt" style="padding:0px;margin:0px">
                  <button v-show="$per.value.saveInstallmentPaymrnt" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
                  <button v-show="($per.value.saveInstallmentPaymrnt && record.id === 0 ) || ($per.value.editInstallmentPaymrnt && record.id > 0 )" @click='saveData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
                  <button v-show="$per.value.emptyInstallmentPaymrnt" @click='emptyData()' type='button' class='btn btn-outline btn-danger btn-sm'>إفراغ</button>
                  <button v-show="$per.value.deleteInstallmentPaymrnt" @click='deleteData()' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
                  <button v-show="$per.value.deleteAllInstallments" @click='deleteAll()' type='button' class='btn btn-outline btn-warning btn-sm'>حذف الكل</button>
                  <button v-show="$per.value.createInstallments" @click='addAll()' type='button' class='btn btn-outline btn-warning btn-sm' data-toggle='modal' data-target='#addInstallments'>إضافة أقساط</button>
                </div> -->
              </div>
            </div>
            <div class="col-lg-6 col-sm-6" style='padding: 0px;'>
              <div  style="padding: 30px 0px 0px 0px;">
                <div class="panel panel-default">
                  <div class="panel-heading" style="height: 25px;padding: 2px 2px 0px 0px;text-align:center;">
                       أقساط مجزئة
                  </div>
                <table width='100%' class='table  table-bordered ' >
                      <thead>
                        <tr>
                          <th style='width:5%;padding:2px;text-align: center'>م</th>
                          <th style='width:15%;padding:2px;text-align: center'>المدفوع</th>
                          <th style='width:35%;padding:2px;text-align: center'>ت. السداد</th>
                          <th style='width:45%;padding:2px;text-align: center'>المحصل</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :class="{highlight :selectedSubrec == subRecord.id}" v-for='(subRecord,index) in subRecords' :key='subRecord.id'  v-on:click="fillSubRec(subRecord)">
                          <td style='width:5%;padding:2px;text-align: center'>{{index+1}}</td>
                          <td style='width:15%;padding:2px;text-align: center'>{{subRecord.payed}}</td>
                          <td style='width:35%;padding:2px;text-align: center'>{{subRecord.payment_date}}</td>
                          <td style='width:45%;padding:2px;text-align: center'>{{subRecord.collector_name}}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
            <table width='100%' class='table  table-bordered ' >
                    <thead>
                      <tr>
                        <th style='text-align: center'></th>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>ت. الاستحقاق</th>
                        <th style='text-align: center'>المبلغ</th>
                        <th style='text-align: center'>ت. السداد</th>
                        <th style='text-align: center'>المدفوع</th>
                        <th style='text-align: center'>المحصل</th>
                        <th style='text-align: center'>الباقى</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr :class="{highlight :selectedrec == record.id}"  v-for='(record,index) in records' :key='record.id' v-on:click="showForm(record)">
                        <td  v-if='record.sub_count === 0' style="width:2%;padding:2px" align='center'></td>
                        <td  v-if='record.sub_count > 0' style="width:2%;padding:2px" align='center'><i class="fa fa-plus"></i></td>
                        <td style="width:3%;padding:2px" align='center'>{{index+1}}</td>
                        <td style="width:17%;padding:2px" align='center'>{{record.due_date}}</td>
                        <td style="width:12%;padding:2px" align='center'>{{record.amount}}</td>
                        <td style="width:17%;padding:2px" align='center'>{{record.payment_date}}</td>
                        <td style="width:12%;padding:2px" align='center'>{{record.total_paid}}</td>
                        <td style="width:25%;padding:2px" align='center'>{{record.collector_name}}</td>
                        <td style="width:12%;padding:2px" align='center'>{{record.amount - record.total_paid}}</td>
                      </tr>
                    </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
          <!-- /.col-lg-12 -->
       </div>

       <!-- Modal -->
       <div class='modal fade' id='addInstallments' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
           <div class='modal-dialog  modal-sm'>
               <div class='modal-content'>
                   <div class='modal-header'>
                       <button type='button' class='close'  data-toggle='modal' data-target='#addInstallments' aria-hidden='true'>&times;</button>
                       <h4 class='modal-title' id='myModalLabel'>إضافة أقساط</h4>
                   </div>
                   <form role='form'>
                   <div class='modal-body'>
                     <div class='alert alert-danger alert-dismissable' v-if='errorAddShow'>
                       <ul v-if='validationAddErrors'>
                           <li v-for='err in validationAddErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                       </ul>
                     </div>
                     <div class='alert alert-success alert-dismissable' v-if='successAddShow'>
                      تم اضافة الأقساط بنجاح
                     </div>
                     <fieldset>
                       <div class='form-group col-lg-12 col-sm-12'>
                           <span>عدد الأقساط:</span>
                           <input v-model='iCount' class='form-control' name='branchname' type='text'>
                       </div>
                       <div class='form-group col-lg-12 col-sm-12'>
                           <span>قيمة القيسط:</span>
                           <input v-model='iAmount' class='form-control' name='branchname' type='text'>
                       </div>
                       <div class='form-group col-lg-12 col-sm-12'>
                           <span>بداية السداد:</span>
                           <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='iStart'></Datepicker>
                       </div>
                         </fieldset>
                     </div>
                     <div class='modal-footer'>
                         <button type='button' class='btn btn-default' data-toggle='modal' data-target='#addInstallments'>خروج</button>
                         <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                         <button @click='createInstallments()' type='button' class='btn btn-primary'>حفظ</button>
                     </div>
                   </form>
               </div>
               <!-- /.modal-content -->
           </div>
           <!-- /.modal-dialog -->
       </div>
       <!-- /.modal -->

    <!-- /.container-fluid -->
</div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import Datepicker from '@4keys/vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
  components: {
    Datepicker
  },
  name: 'installment_paymrnts',
  data () {
    return {
      ar: ar,
      isFromReceipt: false,
      contentVisible: false,
      successAddShow: false,
      validationErrors: '',
      validationAddErrors: '',
      records: {},
      recNum: 0,
      record: {},
      subRecords: {},
      treasuries: {},
      collectors: {},
      errorShow: false,
      successShow: false,
      isLoadingAddSave: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      errorAddShow: false,
      selectedSubrec: 0,
      remaining: 0,
      selectedrec: 0,
      total_paid: 0,
      iCount: '',
      iAmount: '',
      iStart: '',
      success: '',
      emptyRecid: 0,
      Localcontract_id: 0,
      branches: {},
      Localrecord_id: 0,
      collectorLocked: false
    }
  },
  mounted: function () {
    this.$watch('record', function () {
      this.remaining = ((this.record.amount - this.total_paid) - this.record.payed || 0)
      if (this.remaining < 0) {
        this.record.payed = this.record.amount - this.total_paid
      }
    }, {deep: true})
  },
  methods: {
    emptyData () {
      if (this.record.main_id === 0) {
        this.emptyRecid = this.record.id
      } else {
        this.emptyRecid = this.record.main_id
      }
      this.isLoadingSave = true
      this.Localrecord_id = this.record.id
      axios.post(this.$apiURL + 'emptyInstallmentPaymrnt', {
        token: localStorage.getItem('token'),
        id: this.emptyRecid,
        selectedrec: this.selectedrec,
        contract_id: this.record.contract_id,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].payments = res.data.data
          this.records = res.data.data
          this.isLoadingSave = false
          this.errorShow = false
          if (this.record.id !== 0) {
            if (this.record.main_id === 0) {
              let r = this.records.findIndex(x => x.id === this.record.id)
              this.record = this.records[r]
            } else {
              let r = this.records.findIndex(x => x.id === this.record.main_id)
              this.record = this.records[r]
            }
            this.showForm(this.record)
            this.selectedrec = this.record.id
          }
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    addAll () {
      this.iCount = ''
      this.iAmount = ''
      this.iStart = ''
      this.isLoadingAddSave = false
      this.errorAddShow = false
      this.successAddShow = false
    },
    changeTreasury (id) {
      if (this.record.treasury_id === 0) {
        this.collectorLocked = true
        this.record.collector_id = ''
      } else {
        this.collectorLocked = false
      }
    },
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        let emptyRec = {id: 0, name: 'خصم'}
        this.treasuries = this.branches[i].treasuries
        this.collectors = this.branches[i].collectors
        this.treasuries.unshift(emptyRec)
      }
    },
    deleteAll () {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف جميع الأقساط لهذا العقد!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteAllInstallments', {
            token: localStorage.getItem('token'),
            contract_id: this.record.contract_id,
            customer_id: this.$store.state.customerData.id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف الأقساط بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, this.record.contract_id, res.data.totals[0].balance)
              let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
              this.$store.state.customerData.contract[i].payments = res.data.data
              this.records = res.data.data
              if (this.record.id !== 0) {
                if (this.record.main_id === 0) {
                  let r = this.records.findIndex(x => x.id === this.record.id)
                  this.record = this.records[r]
                } else {
                  let r = this.records.findIndex(x => x.id === this.record.main_id)
                  this.record = this.records[r]
                }
                this.showForm(this.record)
                this.selectedrec = this.record.id
              }
            })
        }
      })
    },
    createInstallments () {
      this.isLoadingAddSave = true
      this.Localrecord_id = this.record.id
      axios.post(this.$apiURL + 'createInstallments', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id,
        i_count: this.iCount,
        i_amount: this.iAmount,
        i_start: this.iStart,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingAddSave = false
          this.errorAddShow = false
          this.successAddShow = true
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].payments = res.data.data
          this.records = res.data.data
          if (this.record.id !== 0) {
            if (this.record.main_id === 0) {
              let r = this.records.findIndex(x => x.id === this.record.id)
              this.record = this.records[r]
            } else {
              let r = this.records.findIndex(x => x.id === this.record.main_id)
              this.record = this.records[r]
            }
            this.showForm(this.record)
            this.selectedrec = this.record.id
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationAddErrors = err.response.data.errors
          this.errorAddShow = true
          this.isLoadingAddSave = false
        })
    },
    GetData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // -----------------------------------------------------
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.UpdateData(this.$store.state.customerData.branche_id)
      this.showForm(0)
      this.records = {}
      this.record = {}
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    tabSelected (type) {
      this.GetData()
      if (type === 1) {
        this.isFromReceipt = true
      } else {
        this.isFromReceipt = false
      }
      this.record.contract_id = ''
      this.records = this.$store.state.customerData.contract[0].payments
      this.showForm(0)
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.subRecords = 0
      this.error = ''
      this.selectedSubrec = 0
      if (recID === 0) {
        this.Localcontract_id = this.record.contract_id
        this.selectedrec = 0
        this.record = {'id': 0, 'contract_id': recID.contract_id, 'due_date': '', 'payed': null, 'total_paid': 0, 'amount': '', 'payment_date': '', 'treasury_id': '', 'user_id': '', 'collector_id': '', 'treasury_name': '', 'collector_name': '', 'main_id': 0, 'receipt_id': ''}
        this.record.contract_id = this.Localcontract_id
      } else {
        this.record = JSON.parse(JSON.stringify(recID))
        this.subRecords = recID.sub_payments
      }
      if (this.record.total_paid > 0) {
        this.total_paid = this.record.total_paid - this.record.payed
      } else {
        this.total_paid = 0
      }
      this.selectedrec = recID.id
      this.changeTreasury()
    },
    fillSubRec (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      this.selectedSubrec = recID.id
      this.record = JSON.parse(JSON.stringify(recID))
      if (this.record.payed > 0) {
        this.total_paid = this.record.total_paid - this.record.payed
      } else {
        this.total_paid = 0
      }
      this.changeTreasury()
    },
    saveData () {
      this.isLoadingSave = true
      this.Localrecord_id = this.record.id
      axios.post(this.$apiURL + 'saveInstallmentPaymrnt', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        due_date: this.record.due_date,
        amount: this.record.amount,
        payed: this.record.payed,
        totalPayed: this.record.total_paid,
        payment_date: this.record.payment_date,
        treasury_id: this.record.treasury_id,
        receipt_id: this.record.receipt_id,
        collector_id: this.record.collector_id,
        main_id: this.record.main_id,
        user_id: this.record.user_id,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].payments = res.data.data
          this.records = res.data.data
          this.isLoadingSave = false
          this.errorShow = false
          if (this.record.id !== 0) {
            if (this.record.main_id === 0) {
              let r = this.records.findIndex(x => x.id === this.record.id)
              this.record = this.records[r]
            } else {
              let r = this.records.findIndex(x => x.id === this.record.main_id)
              this.record = this.records[r]
            }
            this.showForm(this.record)
            this.selectedrec = this.record.id
          }
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData () {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا القسط نهائيا!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteInstallmentPaymrnt', {
            token: localStorage.getItem('token'),
            selectedSubrec: this.selectedSubrec,
            selectedrec: this.selectedrec,
            contract_id: this.record.contract_id,
            customer_id: this.$store.state.customerData.id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم الحذف بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
              let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
              this.$store.state.customerData.contract[i].payments = res.data.data
              this.records = res.data.data
              this.successShow = false
              this.errorShow = false
              if (this.record.main_id === 0) {
                let r = this.records.findIndex(x => x.id === this.record.id)
                if (r > -1) {
                  this.record = this.records[r]
                  this.selectedrec = this.record.id
                  this.showForm(this.record)
                } else {
                  this.showForm(0)
                  this.selectedrec = null
                }
              } else {
                let r = this.records.findIndex(x => x.id === this.record.main_id)
                if (r > -1) {
                  this.record = this.records[r]
                  this.selectedrec = this.record.id
                  this.showForm(this.record)
                }
              }
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/InstallmentPaymrnt.vue